import { useTheme } from 'styled-components'

import { Logo } from '@/modules/shared/components/logo'
import { CenterLayoutContainer, CenterLayoutContent, CenterLayoutLogo } from './CenterLayout.styled'

import type { ReactNode } from 'react'

type CenterLayoutProps = {
  children?: ReactNode | ReactNode[]
  backgroundColor?: string
}

const CenterLayout = ({ children, backgroundColor }: CenterLayoutProps) => {
  const theme = useTheme()
  return (
    <CenterLayoutContainer backgroundColor={backgroundColor ?? theme.Colors.Background.White}>
      <CenterLayoutLogo>
        <Logo />
      </CenterLayoutLogo>

      <CenterLayoutContent>{children}</CenterLayoutContent>
    </CenterLayoutContainer>
  )
}

export { CenterLayout }
